import {
  Component,
  inject,
} from '@angular/core';
import {AsyncPipe} from '@angular/common';
import {MatButton} from '@angular/material/button';
import {Store} from '@ngrx/store';
import {MatDialog} from '@angular/material/dialog';
import {TranslatePipe} from '@ngx-translate/core';
import {AppState} from '../../store/store';
import {selectBrokerLogo} from '../../store/contact/contact.selectors';
import {HeaderMenuDialogComponent} from '../header-menu-dialog/header-menu-dialog.component';
import {HeaderPanelComponent} from '../header-panel/header-panel.component';
import {SquareIconButtonComponent} from '../square-icon-button/square-icon-button.component';
import {logout} from '../../store/auth/auth.actions';
import {selectLoggedIn} from '../../store/auth/auth.selectors';
import {CommonSpacerComponent} from '../common-spacer/common-spacer.component';

@Component({
  selector: 'app-header',
  imports: [TranslatePipe, HeaderPanelComponent, SquareIconButtonComponent, CommonSpacerComponent, MatButton,
    AsyncPipe],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent {

  private store: Store<AppState> = inject(Store<AppState>);

  private dialog: MatDialog = inject(MatDialog);

  readonly brokerLogo$ = this.store.select(selectBrokerLogo);

  readonly loggedIn$ = this.store.select(selectLoggedIn);

  handleLogout(): void {
    this.store.dispatch(logout());
  }

  showMobileMenu(): void {
    this.dialog.open(HeaderMenuDialogComponent, {
      position: {top: '0'},
      minWidth: '100%',
      data: {},
    });
  }

}
